
import { Component, Vue } from "vue-property-decorator";

//компонент "обертка" для удобного использования ui-dropdown
@Component({
  name: "ui-usable-dropdown"
})
export default class LanguageSwitcherComponent extends Vue {
  languages: string[] = [];
  currentLang: string = 'EN';
  async created() {
    try {
      this.languages = await this.$cacheProvider.getLanguagesAsync();
    } catch (error) {
      this.languages = [];
      this.$notification.error(error);
    }
  }
  setLanguage(lang: string) {
    this.currentLang = lang;
    this.$emit('change', lang);
  }
}
